<template>
		<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
			<div class="column-center" v-if="info">
				<h3>재고 신청 상세</h3>
				<el-descriptions title="" direction="vertical" :column="isMobile?2:4" border>
				  <el-descriptions-item label="배송방법">
					  <div v-if="info.delivery_center_code == 'CN_SHIP' || info.delivery_center_code == '해운'" >해상</div>
					  <div v-else-if="info.delivery_center_code == 'CN_AIR' || info.delivery_center_code == '항공'" >항공</div>
					  <div v-else-if="info.delivery_center_code == 'CN_LCL' || info.delivery_center_code == '화물'" >LCL화물</div>
					  <div v-else >{{info.delivery_center_code}}</div>
				  </el-descriptions-item>
				  <el-descriptions-item label="통관방법">
					  <div v-if="info.customs_type == '1' || info.customs_type == '간이통관'" style="color:#409eff;">간이통관</div>
					  <div v-else-if="info.customs_type == '2' || info.customs_type == '목록통관'" style="color:#67c23a;">목록통관</div>
					  <div v-else-if="info.customs_type == '3' || info.customs_type == '사업자통관'" style="color:#67c23a;">사업자통관</div>	
					  <div v-else >{{info.customs_type}}</div>
				  </el-descriptions-item>
				  <el-descriptions-item label="회원명">{{info.username || info.nickname}}</el-descriptions-item>
				  <el-descriptions-item label="상품 총 금액">{{info.total_amount}}</el-descriptions-item>
				  
				   <el-descriptions-item label="수취인명">{{info.realname}}</el-descriptions-item>
				   <el-descriptions-item label="우편번호">{{info.zipcode}}</el-descriptions-item>
				   <el-descriptions-item label="핸드폰">{{info.mobile}}</el-descriptions-item>
				   <el-descriptions-item label="개인통관고유부호">{{info.customs_info}}</el-descriptions-item>
				   <el-descriptions-item label="주소" :span="2">{{info.address}} {{info.detailed_address}}</el-descriptions-item>
				  
				   <el-descriptions-item label="국내 택배사 요청사항">{{info.delivery_message}}</el-descriptions-item>
				   <el-descriptions-item label="관리코드">{{info.refer_code}}</el-descriptions-item>

					<el-descriptions-item label="검토 상태">
						<div v-if="info.status_raw == '0' || info.status == '0'" style="color:#409eff;">{{info.status}}</div>
						<div v-else-if="info.status_raw == '1' || info.status == '1'" style="color:#67c23a;">{{info.status}}</div>
						<div v-else-if="info.status_raw == '2' || info.status == '2'" style="color:#f56c6c;">{{info.status}}</div>	
						<div v-else>{{info.status}}</div>
					</el-descriptions-item>
				</el-descriptions>
				
				<el-descriptions v-for="(item,index) in info.goods" :key="index" style="margin:30px 0" :title="item.goods_name" direction="vertical" :column="isMobile?2:4" border>
					<el-descriptions-item  label="상품 이미지" >
						<el-popover placement="right" trigger="hover" v-if="item.goods_image">
							<el-image 
								style="width: 200px; height: 200px" 
								:src="item.goods_image.startsWith('//') ? 'https:' + item.goods_image : item.goods_image" 
								fit="contain">
							</el-image>
							<el-image slot="reference"
								style="width: 80px; height: 80px; cursor: pointer;"
								:src="item.goods_image.startsWith('//') ? 'https:' + item.goods_image : item.goods_image"
								fit="cover">
							</el-image>	
						</el-popover>
					</el-descriptions-item>
					<el-descriptions-item  label="상품코드" >
						{{item.code}}
					</el-descriptions-item>
					<el-descriptions-item  label="상품명">
						{{item.goods_name}}
					</el-descriptions-item>
					<el-descriptions-item  label="수량">
						{{item.num}}
					</el-descriptions-item>
					<el-descriptions-item  label="단가">
						{{item.price}}
					</el-descriptions-item>
					<el-descriptions-item  label="색상(중국어)">
						{{item.color}}
					</el-descriptions-item>
					<el-descriptions-item  label="사이즈(중국어)">
						{{item.size}}
					</el-descriptions-item>
					<el-descriptions-item  label="바코드">
						{{item.barcode}}
					</el-descriptions-item>
					<el-descriptions-item  label="택배 번호">
						{{item.tracking_no}}
					</el-descriptions-item>
					<el-descriptions-item  label="상품 URL">
						<a :href="item.url" target="_blank">{{item.url}}</a>
					</el-descriptions-item>
					
				</el-descriptions>
				
				
				<div class="content-bottom">
					<el-button @click="onOneList">글목록</el-button>
				</div>
				
			</div>
		</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		props: ['id'],
		data() {
			return {
				info:"",
				loading: true,
			};
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},	
		created() {
			this.getDetail()
		},
		methods: {
			getDetail(){
				this.loading = true
				request.post('/member/Inventory/inventoryDetail',
					{
						id:this.id,
					}
				).then(res => {
					this.loading = false
					console.log(res.data,"inventoryxiangqing")
					if(res.code ==1){
						this.info = res.data
					}			
				}).catch(() => {
					this.loading = false
				});
			},
			onOneList(){
				this.$router.push(`/inventoryList`)
			},
		}
		
		
	}
</script>

<style scoped>
	.column-center h3 {
	    text-align: center;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 60px 0 0 0;
	    margin: 0 0 60px;
	}

	.content-bottom{
		padding:20px;
		display: flex;
		justify-content: end;
	}
	::v-deep th.el-descriptions-item__cell,::v-deep th.el-descriptions-item__label,::v-deep th.is-bordered-label{
		color:#333;
	}
	::v-deep .el-table__header th {
		color: #333; 
		font-size: 13px;
		font-weight: bold;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
</style>
